var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('h1',[_vm._v("Cargar Entrega")]),_c('EntregaLista'),_c('EntregaForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }